export const waLink = (number, text) => {
  const n = (number || "").replace(/[^0-9]/g, "");
  const base = n ? `https://wa.me/${n}` : "https://wa.me/";
  return text ? `${base}?text=${encodeURIComponent(text)}` : base;
};
